import { GET_COUNTS } from "queries/task";

export const bannerQueries = [
  GET_COUNTS
]